<div class="page-container">
  <div class="page-header">
    <h2>External Admin Accounts</h2>
    <button class="btn-primary" (click)="openCreateForm()">+ Create Admin</button>
  </div>

  <!-- Action Message -->
  <div class="action-message" *ngIf="actionMessage">{{ actionMessage }}</div>

  <!-- Create Form -->
  <div class="create-form" *ngIf="showCreateForm">
    <h3>New External Admin</h3>
    <div class="error-message" *ngIf="createError">{{ createError }}</div>

    <div class="form-row">
      <div class="form-group">
        <label>Email *</label>
        <input type="email" [(ngModel)]="newEmail" placeholder="admin@example.com" [disabled]="creating" />
      </div>
      <div class="form-group">
        <label>First Name</label>
        <input type="text" [(ngModel)]="newFirstName" placeholder="First name" [disabled]="creating" />
      </div>
      <div class="form-group">
        <label>Last Name</label>
        <input type="text" [(ngModel)]="newLastName" placeholder="Last name" [disabled]="creating" />
      </div>
    </div>

    <div class="form-row" style="margin-top: 12px;">
      <div class="form-group">
        <label>Temporary Password <span class="label-hint">(leave blank to send setup email instead)</span></label>
        <input type="password" [(ngModel)]="newPassword" placeholder="Min. 8 characters" [disabled]="creating" autocomplete="new-password" />
      </div>
      <div class="form-group">
        <label>Confirm Password</label>
        <input type="password" [(ngModel)]="newConfirmPassword" placeholder="Repeat password" [disabled]="creating || !newPassword" autocomplete="new-password" />
      </div>
    </div>

    <div class="form-actions">
      <button class="btn-primary" (click)="createAdmin()" [disabled]="creating">
        <span *ngIf="!creating">{{ newPassword ? 'Create with Password' : 'Create &amp; Send Setup Email' }}</span>
        <span *ngIf="creating">Creating...</span>
      </button>
      <button class="btn-secondary" (click)="cancelCreate()" [disabled]="creating">Cancel</button>
    </div>
  </div>

  <!-- Loading -->
  <div class="loading" *ngIf="loading">Loading admins...</div>

  <!-- Error -->
  <div class="error-message" *ngIf="error">{{ error }}</div>

  <!-- Admins Table -->
  <table class="data-table" *ngIf="!loading && !error">
    <thead>
      <tr>
        <th>Email</th>
        <th>Name</th>
        <th>Password Set</th>
        <th>Status</th>
        <th>Created</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let admin of admins">
        <td>{{ admin.email }}</td>
        <td>{{ displayName(admin) }}</td>
        <td>
          <span class="badge" [class.badge-success]="admin.hasPassword && !admin.mustChangePassword" [class.badge-warning]="!admin.hasPassword || admin.mustChangePassword">
            {{ !admin.hasPassword ? 'Pending Setup' : admin.mustChangePassword ? 'Must Change' : 'Set' }}
          </span>
        </td>
        <td>
          <span class="badge" [class.badge-success]="admin.isActive" [class.badge-danger]="!admin.isActive">
            {{ admin.isActive ? 'Active' : 'Inactive' }}
          </span>
        </td>
        <td>{{ admin.createdDate | date:'dd/MM/yyyy' }}</td>
        <td class="actions">
          <button
            class="btn-action"
            *ngIf="!admin.hasPassword"
            (click)="resendSetupEmail(admin)"
            title="Resend setup email">
            Resend Email
          </button>
          <button
            class="btn-action"
            [class.btn-danger]="admin.isActive"
            (click)="toggleActive(admin)">
            {{ admin.isActive ? 'Deactivate' : 'Activate' }}
          </button>
          <button
            class="btn-action btn-danger"
            (click)="deleteAdmin(admin)"
            title="Delete admin account">
            Delete
          </button>
        </td>
      </tr>
      <tr *ngIf="admins.length === 0">
        <td colspan="6" class="empty-state">No external admin accounts yet.</td>
      </tr>
    </tbody>
  </table>
</div>
